import type { Namespaces } from 'bundles/epic/__generated__/namespaces';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import type { MerchandisingHeroModuleFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

export const getAIDubbingCampaignExperiment = () => {
  const experimentNames = [
    'AIDubbingCampaignFrench',
    'AIDubbingCampaignGerman',
    'AIDubbingCampaignSpanish',
    'AIDubbingCampaignPortuguese',
  ] as Array<keyof Namespaces['GrowthDiscovery']>;

  return experimentNames.find((name) => GrowthDiscoveryExperiments.get(name) === true);
};

export const getAIDubbingCampaignRegionName = (experimentName: keyof Namespaces['GrowthDiscovery']) => {
  switch (experimentName) {
    case 'AIDubbingCampaignFrench':
      return 'french';
    case 'AIDubbingCampaignGerman':
      return 'german';
    case 'AIDubbingCampaignSpanish':
      return 'spanish';
    case 'AIDubbingCampaignPortuguese':
      return 'portuguese';
    default:
      return '';
  }
};

export const getAIDubbingCampaignContent = (
  regionalHeroModules?: Array<MerchandisingHeroModuleFieldsFragment | null> | null,
  experimentName?: keyof Namespaces['GrowthDiscovery']
) => {
  if (!regionalHeroModules?.length || !experimentName) {
    return undefined;
  }

  return regionalHeroModules.find(
    (module) => module?.region?.toLowerCase() === getAIDubbingCampaignRegionName(experimentName)
  );
};
